// extracted by mini-css-extract-plugin
export var attachment = "_qa-a";
export var emailContainer = "_qa-4";
export var emailContentPaddedContainer = "_qa-b";
export var emailHeader = "_qa-6";
export var emailIframe = "_qa-3";
export var emailInfoIcon = "_qa-9";
export var emailShortenedSummary = "_qa-e";
export var infoDropdown = "_qa-0";
export var infoRowBoundedContent = "_qa-d";
export var internal = "_qa-5";
export var merchant = "_qa-8";
export var messageInputContainer = "_qa-h";
export var normal = "_qa-7";
export var replyCard = "_qa-f";
export var subtleButton = "_qa-1";
export var subtleButtonIconContainer = "_qa-2";
export var toggleViewRepliesButton = "_qa-c";
export var wrappingText = "_qa-g";